import { render, staticRenderFns } from "./LanguageCertificate.vue?vue&type=template&id=06f06f76&"
import script from "./LanguageCertificate.vue?vue&type=script&lang=js&"
export * from "./LanguageCertificate.vue?vue&type=script&lang=js&"
import style0 from "./LanguageCertificate.vue?vue&type=style&index=0&id=06f06f76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports